function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 256 256"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeMiterlimit: 10,
    d: "M26.98 5.99a1 1 0 0 0-.687.303L11 21.586l-6.293-6.293a1 1 0 1 0-1.414 1.414l7 7a1 1 0 0 0 1.414 0l16-16a1 1 0 0 0-.727-1.717",
    fontFamily: "none",
    fontSize: "none",
    fontWeight: "none",
    style: {
      mixBlendMode: "normal"
    },
    textAnchor: "none",
    transform: "scale(8.53333)"
  }));
};
export default SvgCheck;